import { z } from 'zod';
import { ConstructionIndexItemSchema } from './valuation-cost';
const ConstructionIndicesShape = {
    indices: z.record(z.string(), ConstructionIndexItemSchema),
};
export const ConstructionIndicesSchema = z.object(ConstructionIndicesShape);
